__turbopack_context__.v({
  "k1Table": "ClientK1DistributionDialog-module__7VoHha__k1Table",
});
